export default __webpack_public_path__ + "static/media/010601020708020506.7271c522.mp4";